import { render, staticRenderFns } from "./CartedDishesIndex.vue?vue&type=template&id=fb8e0416&"
import script from "./CartedDishesIndex.vue?vue&type=script&lang=js&"
export * from "./CartedDishesIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports